import { useCallback, useEffect, useState } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CallInsightAccordionType } from '../types';

type CallInsightPanelState = {
  defaultAccordion: CallInsightAccordionType | null;
  defaultHighlightedTaskId: string | null;
  showCallIntelInsights: boolean;
  channelId?: string;
};
export const useCallInsightPanelState = ({
  defaultAccordion,
  defaultHighlightedTaskId,
  showCallIntelInsights,
  channelId,
}: CallInsightPanelState) => {
  const [activeAccordion, setActiveAccordion] = useState<CallInsightAccordionType | null>(
    defaultAccordion === 'callIntel' && !showCallIntelInsights ? 'aboutThisCall' : defaultAccordion
  );
  const [highlightedTaskId, setHighlightedTaskId] = useState<string | null>(defaultHighlightedTaskId);
  const [unsavedChangesConfig, setUnsavedChangesConfig] = useState<CallIntelTypes.UnsavedEditChangesConfig>({
    actionType: 'NO_ACTION',
    dontAskAgain: false,
    entity: '',
    hasUnsavedChanges: false,
  });

  const handleUnsavedChangesConfig = useCallback(
    (config: CallIntelTypes.UnsavedEditChangesConfig) =>
      setUnsavedChangesConfig((prevConfig) => ({ ...prevConfig, ...config })),
    []
  );

  useEffect(() => {
    setActiveAccordion(defaultAccordion === 'callIntel' && !showCallIntelInsights ? 'aboutThisCall' : defaultAccordion);
  }, [defaultAccordion, showCallIntelInsights, channelId]);

  return {
    activeAccordion,
    highlightedTaskId,
    unsavedChangesConfig,
    setActiveAccordion,
    setHighlightedTaskId,
    setUnsavedChangesConfig: handleUnsavedChangesConfig,
  };
};
